import { DialogController } from 'aurelia-dialog';
import { autoinject } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';
import { PdfPreviewController } from 'elements/pdf-preview-controller';
import { AsyncErrorHandler, MnDialog } from 'lib/ui';
import { PenDto } from 'models/pen/Pen';
import { PenDimensionPipeDto, PenDimensionpipePlacementTranslation } from 'models/pen/PenDimensionPipe';
import { PenDimensionPipeService } from 'services/pen/pen-dimension-pipe-service';

export type PenSegmentWeldingLogCreateDialogArgs = {
  pen: PenDto;
};

export type PenSegmentWeldingLogDto = {
  pen: PenDto;
  pipes: string;
  all: boolean;
};

@autoinject
export class PenSegmentWeldingLogCreateDialog extends MnDialog<PenSegmentWeldingLogCreateDialogArgs, void> {
  private options = [];
  private all: boolean = false;

  private pen: PenDto;
  private penDimensionPipes: PenDimensionPipeDto[];

  private penSegmentWeldingLogDto: PenSegmentWeldingLogDto = {
    pen: undefined,
    pipes: undefined,
    all: undefined,
  };

  constructor(
    dc: DialogController,
    private penDimensionPipeService: PenDimensionPipeService,
    private t: I18N,
    private pdfPreviewController: PdfPreviewController
  ) {
    super(dc);
  }

  get previewText() {
    return `${this.t.tr('general.generateWeldingLog')}`;
  }

  async activate(args?: PenSegmentWeldingLogCreateDialogArgs) {
    if (!args || !args.pen?.Id) return;
    this.pen = args.pen;
    this.penSegmentWeldingLogDto.pen = args.pen;
    await this.getPenDimensionPipes(this.pen.PenDimensionId);
  }

  @AsyncErrorHandler
  async getPenDimensionPipes(penDimensionId: number) {
    const data = await this.penDimensionPipeService.getAll('?$filter=PenDimensionId eq ' + penDimensionId);

    this.penDimensionPipes = data
      .map((pipe) => ({
        ...pipe,
        Name: this.t.tr<string>(PenDimensionpipePlacementTranslation[pipe.Placement]),
      }))
      .sort((a, b) => a.Placement - b.Placement);
  }

  protected previewProgress = false;
  protected async previewWeldingLog() {
    this.previewProgress = true;
    this.penSegmentWeldingLogDto.pipes = this.options.join(',');
    this.penSegmentWeldingLogDto.all = this.all;
    const blob = await this.penDimensionPipeService.previewWeldingLog(this.penSegmentWeldingLogDto);
    void this.pdfPreviewController.openPdfPreview(blob);
    this.previewProgress = false;
  }

  private optionsChanged() {
    if (this.options.length > 0) {
      this.all = undefined;
    }
  }

  private allChanged() {
    if (this.all !== null) {
      this.options = [];
    }
  }
}
